module.exports = jWeixin;